export default __webpack_public_path__ + "assets/products/product-cleaning-mid-stay.28cda1002d2aa39fc78dc9b649433606.webp";